import { Component, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'smart-cart-form-token-section',
  templateUrl: './token-section.component.html',
  styleUrls: ['./token-section.component.scss'],
  standalone: false,
})
export class SmartCartFormTokenSectionComponent implements OnChanges {
  @Input({ required: true }) token!: string;

  readonly tokenControl = new FormControl<string>('', { nonNullable: true });

  ngOnChanges(): void {
    this.tokenControl.setValue(this.token ?? '');
  }
}
